import styled from 'styled-components';
import device, { pageMaxWidth } from '../../../components/mediaQueries';

const MainBodyWrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  width: 100%;
  max-width: ${pageMaxWidth};
  padding-top: 205px;
  ${device.desktop`
    padding-left: 20px;
    padding-right: 20px;`}
  ${device.largeDesktop`
    padding-left: 0;
    padding-right: 0;`}
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export default MainBodyWrapper;
